import React from 'react';
const WhyChooseUsSection = () => {
  const reasons = [{
    title: 'Faith Meets Finance',
    description: 'We uniquely combine biblical truth with modern wealth-building tools. Our clients grow not just in income but in impact and alignment with their God-given calling.'
  }, {
    title: 'We Live What We Coach',
    description: "Our coaching comes from real wins and real war rooms. We've battled through financial storms, marital restoration, business setbacks-and we came out stronger."
  }, {
    title: 'Couple Coaching Advantage',
    description: 'As a husband-wife team, we bring both masculine and feminine leadership perspectives, helping couples align in communication, money, and mission.'
  }, {
    title: 'Legacy-Centered Coaching Ecosystem',
    description: 'From Legacy Lab to Royal Alliance, Kingsmen and Queendom, we provide one of the only frameworks that develops your life across wealth, relationships, and spiritual growth.'
  }, {
    title: 'Faith-Based. Family-Focused. Financially Proven.',
    description: 'We help people make money without losing their soul or family. Our approach prioritizes God, growth, and generational stewardship.'
  }, {
    title: 'National Reach, Personal Touch.',
    description: "We've shared stages with icons like Kobe Bryant, ET, and Patrick Lencioni, and sat at tables with Les Brown and Master P-but we're still just one message away for the people we serve."
  }, {
    title: 'We Build Kingdoms, Not Just Cashflow',
    description: "Our clients don't just get tools. They get transformed into leaders, wealth-builders, lovers, and legacy leavers who make impact for generations."
  }];
  return <section className="w-full py-24 bg-gradient-to-b from-gold-50 to-white observer-element" data-id="element-316">
      <div className="container mx-auto px-4" data-id="element-317">
        <div className="max-w-5xl mx-auto border border-gold-200 rounded-3xl p-12 bg-white shadow-xl" data-id="element-318">
          <h2 className="text-5xl font-bold text-gradient mb-6" data-id="element-319">
            Why choose us?
          </h2>
          <p className="text-xl mb-12 text-gray-700" data-id="element-320">
            Here's 7 reasons that set us apart:
          </p>
          <div className="space-y-8" data-id="element-321">
            {reasons.map((reason, index) => <div key={index} className="fade-item" data-id="element-322">
                <h3 className="text-gold-600 font-semibold mb-3 text-xl" data-id="element-323">
                  {reason.title}
                </h3>
                <p className="text-gray-700" data-id="element-324">{reason.description}</p>
              </div>)}
          </div>
          <div className="mt-12 text-center" data-id="element-325">
            <a href="https://expert.minnect.com/@CurtisAndSpringEatmon" target="_blank" rel="noopener noreferrer" className="btn-legacy-gold inline-flex items-center justify-center" data-id="element-326">
              Follow us on Minnect
            </a>
          </div>
        </div>
      </div>
    </section>;
};
export default WhyChooseUsSection;